import React from 'react';

const Spinner = ({ size, fullScreen, fixed }) => {
  const style = fullScreen ? { height: "calc(100vh - 136px)"} : {}
  return(
    <div className="full-width flex align-items-center justify-center" style={style}>
      <div className={`spinner ${size} ${fixed ? "fixed" : ""}`} />
    </div>
  )
}

export default Spinner;
